import {useIntl} from 'react-intl';
import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import {ComponentContainer} from "../../../lib/template/ComponentContainer";
import {ReactiveTable} from "react-ive-tables";
import {UnprocessedBankTransactionResponse} from "../../../lib/types/types";
import useSWR, {mutate} from "swr";
import {formatNumber} from "../../../lib/common";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import CreatePayments from "./createPayments/CreatePayments";
import CreateAdvancePayments from "./createAdvancePayments/CreateAdvancePayments";
import moment from "moment/moment";
import {useDialog} from "../../../lib/hooks/useDialog";
import DiscardTransaction from "./discardTransaction/DiscardTransaction";

interface Props {

}


const UnprocessedTransactions: React.FC<Props> = props => {
    const {formatMessage: f} = useIntl();
    const didMountRef = useRef(false);
    const {showConfirmDialog} = useDialog();

    const [showAddPaymentDialog, setShowAddPaymentDialog] = useState(false);
    const [showAdvancePaymentDialog, setShowAdvancePaymentDialog] = useState(false);
    const [selectedTransaction, setSetSelectedTransaction] = useState<UnprocessedBankTransactionResponse>();
    const [showDiscardDialog, setShowDiscardDialog] = useState(false);

    const {data: unprocessedTransactionsTableData} = useSWR<UnprocessedBankTransactionResponse[]>(`/bank/transactions/unprocessed`);

    useEffect(() => {
        if (!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);

    const getColumnTemplate = () => {
        return {
            valueDate: (rowData: UnprocessedBankTransactionResponse) => moment(rowData.valueDate).format("DD-MM-YYYY"),
            amount: (rowData: UnprocessedBankTransactionResponse) => formatNumber(rowData.amount),
            remainingAmount: (rowData: UnprocessedBankTransactionResponse) => formatNumber(rowData.remainingAmount),
            operations: (rowData: UnprocessedBankTransactionResponse) => <div
                className={"flex justify-content-center gap-1"}>
                <Button icon={'pi pi-plus-circle'} className={'mr-2'}
                        tooltip={f({id: 'addPayment'})}
                        tooltipOptions={{position: 'top'}}
                        onClick={() => {
                            setSetSelectedTransaction(rowData)
                            setShowAddPaymentDialog(true);
                        }}/>
                <Button icon={'fal fa-wallet'} className={'mr-2'}
                        tooltip={f({id: 'advancePayment'})}
                        tooltipOptions={{position: 'top'}}
                        onClick={() => {
                            setSetSelectedTransaction(rowData)
                            setShowAdvancePaymentDialog(true);
                        }}/>
                <Button icon={'fal fa-times'} className={'mr-2'}
                        tooltip={f({id: 'removeFromList'})}
                        severity={"danger"}
                        tooltipOptions={{position: 'top'}}
                        onClick={() => {
                            setSetSelectedTransaction(rowData);
                            setShowDiscardDialog(true);
                        }}/>
            </div>
        }
    }

    const handleCloseDialog = async () => {
        await mutate("/bank/transactions/unprocessed");
        await mutate(`/bank/transactions/${selectedTransaction?.id}`);
        setShowAddPaymentDialog(false);
        setShowAdvancePaymentDialog(false);
        setShowDiscardDialog(false);
        setSetSelectedTransaction(undefined);
    }

    return <>
        <ComponentContainer componentName={f({id: "unprocessedTransactions"})}>

            <ReactiveTable
                data={unprocessedTransactionsTableData}
                totalRecords={unprocessedTransactionsTableData?.length}
                ignoreFilters={['rowIndex', 'operations']}
                showHeader={false}
                columnTemplate={getColumnTemplate()}
                showPaginator={false}
                columnOrder={['clientName', 'bankReference', 'valueDate', 'amount', 'remainingAmount', 'paymentDetails', 'operations']}
                specialLabels={{
                    clientName: "client",
                }}
                columnStyle={{
                    operations: {
                        header: {},
                        body: {width: '1px'}
                    }
                }}
            />

        </ComponentContainer>

        {showAddPaymentDialog && (
            <Dialog breakpoints={{'960px': '75vw', '640px': '100vw'}} style={{minWidth: '75vw'}}
                    header={f({id: 'addPaymentsForClient'}, {clientName: selectedTransaction?.clientName})}
                    onHide={handleCloseDialog} visible={showAddPaymentDialog}
            >
                <CreatePayments transactionId={selectedTransaction?.id} onClose={handleCloseDialog}/>
            </Dialog>
        )}

        {showAdvancePaymentDialog && (
            <Dialog breakpoints={{'960px': '75vw', '640px': '100vw'}} style={{minWidth: '75vw'}}
                    header={f({id: 'advancePayment'}, {clientName: selectedTransaction?.clientName})}
                    onHide={handleCloseDialog} visible={showAdvancePaymentDialog}
            >
                <CreateAdvancePayments transactionId={selectedTransaction?.id} onClose={handleCloseDialog}/>
            </Dialog>
        )}

        {selectedTransaction &&
            <Dialog header={f({id: "removeFromList"})}
                    onHide={handleCloseDialog}
                    breakpoints={{'960px': '75vw', '640px': '100vw'}}
                    visible={showDiscardDialog}>

                <DiscardTransaction selectedTransaction={selectedTransaction} onClose={handleCloseDialog}/>
            </Dialog>
        }
    </>
};

export default UnprocessedTransactions
